import {useRouter} from 'next/router';
import LeftNavItem from "/components/shared/navigation/LeftNavItem";
import {useContext} from "react";
import EventContext from "/context/EventContext";
import GoldButton from "/components/shared/buttons/GoldButton";
import {isSubset} from "/utils";
import {SvgEventTicket} from "/components/shared/SvgIcons";

export default function LeftNav({items, production, id}) {
    const router = useRouter();
    const {slug, nav} = router.query;
    const {event} = useContext(EventContext);

    const setUrl = (item) => {
        const navUrl = router.asPath.split('#')[1];
        return isSubset({nav: navUrl}, item.url);
    };

    return (
        <div>
            <h1 className="hidden md:block w-56 text-lg text-black-medium break-words">
                {(event || {}).title}
            </h1>
            <div className='xl:w-64 xl:ml-0 md:mr-12 flex flex-col'>
                <nav className=" flex flex-col mt-4 xl:mt-2 cursor-pointer" id={id}>
                    {items.map((item, index) => {
                        const fullUrl = {
                            pathname: router.pathname,
                            query: Object.assign({}, router.query, item.url)
                        };
                        if ((item.label === 'details' && event.custom_data?.details_html !== null) || (item.label === 'Zusatzmaterial' && event.products.length === 0)) {
                            return null;
                        } else
                            return (
                                <LeftNavItem
                                    key={item.label}
                                    label={item.label}
                                    active={setUrl(item)}
                                    url={fullUrl}
                                    index={index}
                                />
                            );
                    })}

                </nav>
                {router.pathname.includes('about-theater') ? '' :
                    (<div className='hidden md:block my-6'>
                            <GoldButton
                                onClick={() => router.push('#tickets')}
                                icon={<div className="mr-2 mb-1">{SvgEventTicket()}</div>}
                                style='rounded-full px-3 pt-2 pb-1 text-base'
                            >
                                Tickets kaufen
                            </GoldButton>
                            <GoldButton
                                onClick={() => router.push(`/ticket-validation/${slug}`)}
                                icon={<div className="mr-2 mb-1">{SvgEventTicket()}</div>}
                                style='rounded-full px-4 pt-2 pb-1 text-base mt-4'
                            >
                                Code einlösen
                            </GoldButton>
                        </div>
                    )}
            </div>
        </div>
    );
}

